import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86dea19e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Order Edit")
  ])
], -1))
const _hoisted_4 = { class: "col-md-6 mt-4" }
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Order Status", -1))
const _hoisted_8 = { class: "form-floating" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Courier Note", -1))
const _hoisted_10 = {
  key: 0,
  class: "form-floating"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Cancel Note", -1))
const _hoisted_12 = { class: "form-floating" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Unassign", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Rider", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.orderstatus_id) = $event)),
              class: "form-control"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orderstatuses, (orderstatus) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: orderstatus.id,
                  value: orderstatus.id
                }, _toDisplayString(orderstatus.name), 9, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.data.orderstatus_id]
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.courier_note) = $event)),
              class: "form-control",
              placeholder: "Courier Note"
            }, null, 512), [
              [_vModelText, $setup.data.courier_note]
            ]),
            _hoisted_9
          ]),
          ($setup.data.orderstatus_id===2 || $setup.data.orderstatus_id===3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.cancel_note) = $event)),
                  class: "form-control",
                  placeholder: "Cancel Note",
                  required: ""
                }, null, 512), [
                  [_vModelText, $setup.data.cancel_note]
                ]),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.rider_id) = $event)),
              class: "form-control"
            }, [
              _hoisted_13,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.riders, (rider) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: rider.id,
                  value: rider.id
                }, _toDisplayString(rider.rider_name) + " ( " + _toDisplayString(rider.rider_mobile_no) + ")", 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.data.rider_id]
            ]),
            _hoisted_15
          ]),
          _hoisted_16
        ], 32)
      ])
    ])
  ]))
}